// ✅ إضافة الترجمات
const translations = {
    en: {
        // Navigation
        profile: "Profile",
        salaryBenefits: "Salary",
        attendance: "Attendance",
        leaveManagement: "Leave Management",
        employeeSelfServices: "Self Services",
        employeeChanges: "Employee Changes",
        messages: "Messages",
        calendar: "Calendar",
        settings: "Settings ",
        escalation: "Escalation",
        groups: "Groups",

        // Status Messages
        allowLocationAccess: "Please allow location access...",
        accessRestricted: "Access Restricted",
        outsideOfficeArea: "You are outside the office area",
        distanceFromOffice: "Distance from office",
        meters: "meters",
        moveCloserToOffice: "Move closer to office to access",

        // Feature Lock
        featureNotAvailable: "This feature is not available for your organization. Please contact your administrator.",

        // View Mode
        adminView: "Admin View",
        managerView: "Manager View",
        switchToAdminView: "Switch to Admin View",
        switchToManagerView: "Switch to Manager View",

        // Admin/Nav
        dashboard: "Dashboard",
        employees: "Employees",
        reports: "Reports",
        documents: "Documents",
        leave: "Leave",
        solfa: "Solfa",
        payroll: "Payroll",
        taxCalculator: "Tax Calculator",

        // Powered By
        poweredBy: "Powered by",
    },
    ar: {
        // Navigation
        profile: "الملف الشخصي",
        salaryBenefits: "الراتب ",
        attendance: "الحضور",
        leaveManagement: " الإجازات",
        employeeSelfServices: "الخدمات  ",
        employeeChanges: "تغييرات الموظفين",
        messages: "الرسائل",
        calendar: "التقويم",
        settings: "الإعدادات ",
        escalation: "الشكاوى", // ✅ أضف هذا السطر
        groups: "المجموعات",

        // Status Messages
        allowLocationAccess: "الرجاء السماح بالوصول للموقع...",
        accessRestricted: "الوصول محظور",
        outsideOfficeArea: "أنت خارج منطقة المكتب",
        distanceFromOffice: "المسافة من المكتب",
        meters: "متر",
        moveCloserToOffice: "اقترب من المكتب للوصول إلى",

        // Feature Lock
        featureNotAvailable: "هذه الميزة غير متاحة لمؤسستك. يرجى الاتصال بالمسؤول.",

        // View Mode
        adminView: "عرض الإداري",
        managerView: "عرض المدير",
        switchToAdminView: "التبديل إلى عرض الإداري",
        switchToManagerView: "التبديل إلى عرض المدير",

        // Admin/Nav
        dashboard: "لوحة التحكم",
        employees: "الموظفين",
        reports: "التقارير",
        documents: "المستندات",
        leave: "الإجازات",
        solfa: "السلف",
        payroll: "الرواتب",
        taxCalculator: "حاسبة الضرائب",

        // Powered By
        poweredBy: "مدعوم من",
    }
};

export default translations;